import React, { useRef, useState } from "react";

/**
 * For when you need both a use ref and use state for the same data.
 * This is useful when you attach event handlers to places inaccessible to React's re-render cycle, such as the document.
 * Guarantees up-to-date data inside your handlers much like a ref, but also allows this state to be used in a render function.
 */
export const useRefState = <StateType>(initialState?: StateType): [StateType, React.MutableRefObject<StateType>, SetRefAndState<StateType>] => {
    const [state, setState] = useState<StateType>(initialState);
    const ref = useRef<StateType>(initialState);

    const setRefAndState: SetRefAndState<StateType> = (state: StateType) => {
        ref.current = state;
        setState(state);
    };

    return [state, ref, setRefAndState];
};

type SetRefAndState<T> = React.Dispatch<React.SetStateAction<T>>;
